import http from "../../http-common"

class SearchFilterOptionsService {
    getSearchFilterOptions(sector?:string) {
        return http.get(`/search/filter-options?filter=${sector}`)
    } 
}


export default new SearchFilterOptionsService();